/** Decorative objects never enter resource hit testing or navigation obstacles. */
export const ECOLOGY = {
  fern: {
    name: "卷叶蕨",
    regions: ["grove", "garden"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  flowers: {
    name: "星点花",
    regions: ["garden", "grove"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  root: {
    name: "盘结树根",
    regions: ["grove"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  log: {
    name: "苔覆枯木",
    regions: ["grove"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  reed: {
    name: "水边芦苇",
    regions: ["garden"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  ruin: {
    name: "旧庭残碑",
    regions: ["grove", "quarry"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  stones: {
    name: "细碎层岩",
    regions: ["quarry", "garden"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
  shroom: {
    name: "萤伞菌",
    regions: ["grove"],
    kind: "decoration",
    clickable: false,
    collision: false,
  },
} as const;
export const RESOURCE_VARIANTS = {
  tree: ["庭园阔叶", "林地伞冠", "矿原矮树"],
  berry: ["蜜莓", "金蜜莓"],
  herb: ["清露药草", "银叶药草"],
  rock: ["青晶岩", "蓝晶脉"],
  amber: ["琥珀灵矿", "日耀矿纹"],
};
